import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import Dialog from '@/components/dialogs/Dialog';
import DataModelReportsPanel from './DataModelReportsPanel';
import { hideDataModelReports } from '../actions';

const DataModelReportsDialog = ({
  category,
  code,
  name,
  hide,
  theme,
}) => {
  const intl = useIntl();
  return (
    <Dialog
      title={intl.formatMessage({ id: 'dataset.data.datamodel.reports.for' }, { name })}
      className="smallwizard aridhia-datamodel-reports-dialog"
      onClose={() => hide(category, code)}
      size="large"
      theme={theme}
    >
      <DataModelReportsPanel category={category} code={code} />
    </Dialog>
  );
};

const mapStateToProps = ({
  datasetReports: {
    dataModelReportsDialog: {
      category, code, name,
    },
  },
}) => ({
  category,
  code,
  name,
});

const mapDispatchToProps = {
  hide: hideDataModelReports,
};

export default connect(mapStateToProps, mapDispatchToProps)(DataModelReportsDialog);
